// import React from 'react';
// import Checkbox from '@material-ui/core/Checkbox';
// import Component from 'mson/lib/component';
// import FormControlLabel from '@material-ui/core/FormControlLabel';

import attach from "mson-react/lib/attach";

import { FunctionComponent, useContext, useEffect } from "react";
import { CurrentFormContext, CurrentFormContextValue } from "../../contexts";

interface CurrentFormProps {
  component: any;
  value: CurrentFormContextValue;
}

export const CurrentForm: FunctionComponent<CurrentFormProps> = ({
  component,
}: CurrentFormProps) => {
  const currentForm = useContext(CurrentFormContext);

  useEffect(() => {
    component.setValue(currentForm);
  }, [currentForm, component]);
  return null;
};

const returnValue = attach(["value"])(CurrentForm);

export default returnValue;
